import { Bot, BotCreateBody, Filters } from "@/@types/ivr";
import { BotStatus } from "@/app/ivr/bot/utils/enums";
import httpManager from "@/app/shared/utils/httpManager";
import { toFormData } from "@/app/shared/utils/helpers";

class BotServices {
  private baseUrl = "/ivr";

  async getList(filters: Filters): Promise<Bot[]> {
    const query = new URLSearchParams();

    query.set("name", filters.name ?? "");
    query.set("channel", String(filters.channel ?? ""));
    query.set("status", String(filters.status ?? ""));
    query.set("type", String(filters.type ?? ""));

    const url = `${this.baseUrl}/?${query.toString()}`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async getDetails(id: number | string): Promise<Bot> {
    const url = `${this.baseUrl}/${id}/`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async duplicate(id: number) {
    const url = `${this.baseUrl}/copy/`;

    await httpManager.post(url, { ivr: id });
  }

  async changeStatus(id: number, newStatus: BotStatus) {
    const url = `${this.baseUrl}/${id}/status/`;
    const body = { status: newStatus };

    await httpManager.put(url, body);
  }

  async create(newBot: BotCreateBody): Promise<Bot> {
    const url = `${this.baseUrl}/`;

    const response = await httpManager.post(url, newBot);

    return response.data;
  }

  async uploadOutOfServiceAudio(id: number, body: { out_of_schedule_file_audio: File | Blob }) {
    const url = `${this.baseUrl}/${id}/`;

    if (typeof body.out_of_schedule_file_audio === "string") return;

    const formattedBody = toFormData(body);

    await httpManager.put(url, formattedBody);
  }

  async update(id: number, newBotData: Partial<BotCreateBody>) {
    const url = `${this.baseUrl}/${id}/`;

    return await httpManager.put(url, newBotData);
  }

  async delete(id: number) {
    const url = `${this.baseUrl}/${id}/`;

    await httpManager.delete(url);
  }
}

export const botServices = new BotServices();
